import { render, staticRenderFns } from "./CompanyCarousel.vue?vue&type=template&id=04afe550&scoped=true&"
import script from "./CompanyCarousel.vue?vue&type=script&lang=ts&"
export * from "./CompanyCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyCarousel.vue?vue&type=style&index=0&id=04afe550&scoped=true&lang=scss&"
import style1 from "./CompanyCarousel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04afe550",
  null
  
)

export default component.exports